/**
 * 默认允许缩放和移动
 */
export const DEFAULT_ALLOWZOMMORPAN = true;
